export default __webpack_public_path__ + "static/media/leo.3bad7c40.gif";